
































export default
  name: 'archive'
  mounted: ->
    @projects[0].participation.success = @$store.getters.countPaid
  data: ->
    projects: [
      {
        title: 'Ямочный ремонт дороги КПП-Кафе 2024'
        description: 'ямочный ремонт дороги от остановки до ворот'
        budget: 628000
        budget_details: ''
        participation:
          total: 314
          success: 1
        period: 'июль 2024'
        receipts: []
      }
    ]

